export const shop_quote_line_item_url: string = "shop_quote_line_item";
